module.exports = __webpack_public_path__ + "static/media/klaer-k.59105aed.mp3";